export default __webpack_public_path__ + "static/media/hightlight_detailed_3.9afe746b.svg";